// Controlled list of operationally supported IANA timezones (must match
// backend utils/timezone_utils.SUPPORTED_TIMEZONES).
export const SUPPORTED_TIMEZONES = [
  'Australia/Sydney', 'Australia/Melbourne', 'Australia/Brisbane',
  'Australia/Adelaide', 'Australia/Darwin', 'Australia/Perth',
  'Australia/Hobart', 'Australia/Lord_Howe',
];

// Optional state -> timezone SUGGESTION only (admin must confirm; never auto-applied).
export const STATE_TZ_SUGGESTION = {
  NSW: 'Australia/Sydney', VIC: 'Australia/Melbourne', QLD: 'Australia/Brisbane',
  SA: 'Australia/Adelaide', NT: 'Australia/Darwin', WA: 'Australia/Perth',
  TAS: 'Australia/Hobart', ACT: 'Australia/Sydney',
};
